import { UserAdminRepository } from '../repositories';

import {
  ListerUtilisateursUseCase,
  ObtenirStatistiquesUseCase,
  SupprimerUtilisateurUseCase,
  ChangerRoleUseCase,
  BasculerActivationUseCase,
  VerrouillerCompteUseCase,
  DeverrouillerCompteUseCase,
  MettreAJourUtilisateurUseCase,
  ExporterUtilisateursUseCase,
} from '../../application/use-cases';

// Singleton de l'implementation infrastructure
const userAdminRepository = new UserAdminRepository();

/**
 * Conteneur d'injection de dependances.
 * Instancie les use cases avec leurs dependances.
 */
export const userAdminContainer = {
  // Liste et statistiques
  listerUtilisateursUseCase: new ListerUtilisateursUseCase(userAdminRepository),
  obtenirStatistiquesUseCase: new ObtenirStatistiquesUseCase(userAdminRepository),

  // Actions CRUD
  supprimerUtilisateurUseCase: new SupprimerUtilisateurUseCase(userAdminRepository),
  mettreAJourUtilisateurUseCase: new MettreAJourUtilisateurUseCase(userAdminRepository),

  // Actions de gestion
  changerRoleUseCase: new ChangerRoleUseCase(userAdminRepository),
  basculerActivationUseCase: new BasculerActivationUseCase(userAdminRepository),
  verrouillerCompteUseCase: new VerrouillerCompteUseCase(userAdminRepository),
  deverrouillerCompteUseCase: new DeverrouillerCompteUseCase(userAdminRepository),

  // Export
  exporterUtilisateursUseCase: new ExporterUtilisateursUseCase(userAdminRepository),
} as const;

export type UserAdminContainer = typeof userAdminContainer;
